module.exports = __webpack_public_path__ + "media/images/menu-icon-b644bbfc52e23fa145100989fc9e760c.svg";